/*
 * SO&RO mobile header staging patch — V2
 * Reuses the existing Shopify localization, primary cart and search components.
 * No component, form, route, currency, cart or checkout logic is duplicated.
 */

(() => {
  const MOBILE_QUERY = '(max-width: 749px)';
  const MOBILE_LOCALIZATION_CLASS = 'soandro-mobile-localization';
  const MOBILE_SEARCH_CLASS = 'soandro-mobile-drawer-search';
  const STACK_CLASS = 'soandro-mobile-right-stack';
  let scheduled = false;

  function findParts() {
    const header = document.querySelector('header-component');
    const desktopRight = document.querySelector('[data-testid="header-top-right"]');
    const localization = document.querySelector(
      `dropdown-localization-component.dropdown-localization, .${STACK_CLASS} dropdown-localization-component`
    );
    const cart = document.querySelector(
      `[data-testid="header-top-right"] cart-drawer-component, .${STACK_CLASS} cart-drawer-component`
    );
    const search = document.querySelector('search-button.search-action');
    const drawerUtility = document.querySelector('.menu-drawer__utility-links');
    return { header, desktopRight, localization, cart, search, drawerUtility };
  }

  function ensureMobileStack(header) {
    let stack = header.querySelector(`.${STACK_CLASS}`);
    if (!stack) {
      stack = document.createElement('div');
      stack.className = STACK_CLASS;
      stack.setAttribute('data-soandro-header-staging', 'v2');
      header.appendChild(stack);
    }
    return stack;
  }

  function applyHeaderLayout() {
    scheduled = false;
    const { header, desktopRight, localization, cart, search, drawerUtility } = findParts();
    if (!header || !desktopRight || !localization || !cart) return;

    if (window.matchMedia(MOBILE_QUERY).matches) {
      const stack = ensureMobileStack(header);

      localization.classList.remove('mobile:hidden');
      localization.classList.add(MOBILE_LOCALIZATION_CLASS);
      if (localization.parentElement !== stack) stack.appendChild(localization);

      if (cart.parentElement !== stack) stack.appendChild(cart);

      if (search && drawerUtility) {
        search.classList.add(MOBILE_SEARCH_CLASS);
        if (search.parentElement !== drawerUtility) drawerUtility.prepend(search);
      }
    } else {
      localization.classList.remove(MOBILE_LOCALIZATION_CLASS);
      localization.classList.add('mobile:hidden');
      if (localization.parentElement !== desktopRight) desktopRight.prepend(localization);

      if (search) {
        search.classList.remove(MOBILE_SEARCH_CLASS);
        if (search.parentElement !== desktopRight) {
          const desktopCart = desktopRight.querySelector('cart-drawer-component');
          if (desktopCart) desktopRight.insertBefore(search, desktopCart);
          else desktopRight.appendChild(search);
        }
      }

      if (cart.parentElement !== desktopRight) desktopRight.appendChild(cart);

      const stack = header.querySelector(`.${STACK_CLASS}`);
      if (stack && !stack.children.length) stack.remove();
    }
  }

  function scheduleLayout() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(applyHeaderLayout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleLayout, { once: true });
  } else {
    scheduleLayout();
  }

  window.matchMedia(MOBILE_QUERY).addEventListener('change', scheduleLayout);
  document.addEventListener('shopify:section:load', scheduleLayout);

  const observer = new MutationObserver(scheduleLayout);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
